import { motion } from "framer-motion";

const BLOCKS = [
  {
    text: "You don't have to wait until your friends are free.",
    img: "/images/social/social-1.jpg",
    alt: "Travelers laughing together on a group trip",
  },
  {
    text: "You don't have to find the group.",
    img: "/images/social/social-2.jpg",
    alt: "A small crew of travelers walking together",
  },
  {
    text: "We create the trip and bring the group together.",
    img: "/images/social/social-3.jpg",
    alt: "Group of friends on an adventure at golden hour",
  },
  {
    text: "Your next crew might be people you haven't met yet.",
    img: "/images/social/social-4.jpg",
    alt: "Travelers sharing a moment outdoors",
  },
];

export const BrandStory = () => (
  <section className="py-16 sm:py-24" data-testid="brand-story-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.7, ease: [0.215, 0.61, 0.355, 1] }}
        className="mb-12 sm:mb-16"
      >
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-flame mb-4">Why Roamies exists</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95]">
          The group is<br />the destination.
        </h2>
      </motion.div>

      <div className="space-y-14 sm:space-y-20">
        {BLOCKS.map((b, i) => (
          <div
            key={i}
            data-testid={`brand-story-block-${i + 1}`}
            className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
          >
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }}
              className={`md:col-span-6 font-display text-3xl sm:text-4xl lg:text-5xl uppercase leading-[1.02] md:[direction:ltr] ${i % 2 === 1 ? "md:text-right" : ""}`}
            >
              {b.text}
            </motion.p>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: "easeOut" }}
              className="md:col-span-6 md:[direction:ltr] relative overflow-hidden aspect-[16/10] border border-ink/10"
            >
              <motion.img
                initial={{ scale: 1.12 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 1.1, ease: "easeOut" }}
                src={b.img} alt={b.alt} loading="lazy"
                className="absolute inset-0 w-full h-full object-cover saturate-[.9]" />
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
